export const snapshotCreationMessages = {
  en: {
    boxTitle: 'Device Management',
    boxHelpText: '',
    columns: {
      family: { name: 'Family', help: '' },
      hostname: { name: 'Hostname', help: '' },
      model: { name: 'Model', help: '' },
      platform: { name: 'Platform', help: '' },
      settingsStates: { name: 'Status', help: '' },
      siteName: { name: 'Site', help: '' },
      sn: { name: 'Serial number', help: '' },
      vendor: { name: 'Vendor', help: '' },
      version: { name: 'Version', help: '' },
      action: { name: 'Action', help: '' },
    },
    deviceSettings: {
      title: 'Detected Issues',
      description:
        '{count, plural, one {# Device has} other {# Devices have}} failed, see details below. Please fix errors.',
      descriptionMissingSns:
        '{count, plural, one {# Device has} other {# Devices have}} will be added also. See details below.',
      descriptionForTable:
        '{count, plural, one {# Device has} other {# Devices have}} failed, see details below. Please fix errors or uncheck failed devices  to Continue with Snapshot',
      missingCredentials:
        '{count, plural, one {# Device has} other {# Devices have}} expired or missing credentials',
      wrongIp:
        '{count, plural, one {# Device is} other {# Devices are}} not included in the included list or {count, plural, one {is} other {are}} excluded',
      notIncluded:
        '{count, plural, one {# Device is} other {# Devices are}} not included in the included list',
      excluded:
        '{count, plural, one {# Device is} other {# Devices are}} excluded',
      missingVendorSettings:
        '{count, plural, one {# Device has} other {# Devices have}} missing API settings, {count, plural, one {select API setting in Status column} other {select API setting for each of them in Status column}}',
      fixItHere: 'fix it here',
      btnRefresh: 'Refresh',
      missingSns:
        'These devices are bound to some other selected device and will be included too:',
      missingSnsMore: '+ {number} more',
    },
    noCredentials: 'Failed Missing credentials',
    unreachableIp: 'Failed IP is not included or is excluded',
    unreachableIpAndNoCredentials:
      'Failed Missing credentials and IP is not included or is excluded',
    noApiSettings: 'Failed Missing Vendor API',
    noApiSettingsSelectPlaceholder: 'Select Vendor API',
    unknownStatus: 'Unknown status',
    hasSettings: 'OK',
    btnPreviousStep: 'Previous Step',
    btnNextStep: 'Continue Discovery',
    waitStarting: 'Wait, starting',
    nextStep: {
      newSnapshot: 'New Snapshot',
      stepper: {
        snapshotCreation: 'Snapshot Creation',
        discoverySettings: 'Discovery Settings',
      },
    },
    addDevices: {
      heading: 'Add Devices',
      btnAddVendor: 'Add Vendor',
      btnCancel: 'Cancel',
      btnToggleAddDevices: 'Add Devices',
      copied: 'Copied to clipboard',
      copyToClipboard: 'Copy to clipboard',
      ipListPlaceholder: 'Insert IP or network',
      ipListTitle: 'Device IP / CIDR',
      rediscoverDevices: 'Rediscover devices with command timeout',
      warnings: {
        largeSubnet:
          'Discovery may take a long time. Number of IP addresses to scan in subnet {subnet} is {ipAddressCount}.',
      },
    },
    bulkActions: {
      deleteDevices: 'Delete Devices',
      newSnapshot: 'New Snapshot',
      refreshDevices: 'Refresh Devices',
    },
    noItemsToSendTitle: 'No items selected',
    noItemsToSendMessage: 'Select at least 1 item',
    confirmDeleteRelated: {
      btnConfirm: 'Delete devices',
      btnSecondaryConfirm: 'Cancel',
      header: 'Associated devices will be deleted as well',
      subHeader:
        'Some of the devices you selected have associated devices that will be deleted along with them. Please see the list of associated devices below:',
    },
    confirmRefreshRelated: {
      btnConfirm: 'Refresh devices',
      btnSecondaryConfirm: 'Cancel',
      header: 'Associated devices will be refreshed as well',
      subHeader:
        'Some of the devices you selected have associated devices that will be updated along with them. Please see the list of associated devices below:',
    },
    confirmCreateRelated: {
      btnConfirm: 'Create snapshot',
      btnSecondaryConfirm: 'Cancel',
      header: 'Associated devices will be added as well',
      subHeader:
        'Some of the devices you selected have associated devices that will be added along with them. Please see the list of associated devices below:',
    },
    selectVendor: {
      openDialogButton: 'Select Vendor API',
      vendorApiSelectLabel: 'Vendor API',
      header: 'Select Vendor API',
      btnConfirm: 'Confirm',
      btnClose: 'Close',
    },
  },
};
